import { GRID_CELL_SIZE, OzGrid, OzGridCell, OzPage } from '@omaze/omaze-ui';
import React, { ReactElement } from 'react';

import { Portal } from '../../shared/Portal/Portal.component';

import styles from './NotFound.styles.css';

export function NotFound (): ReactElement {
    return (
        <Portal el="js-not-found-app__root">
            <div className={styles.pageContainer}>
                <OzPage>
                    <OzGrid>
                        <OzGridCell
                            smSize={GRID_CELL_SIZE.COLUMN_4}
                            mdSize={GRID_CELL_SIZE.COLUMN_8}
                            lgSize={GRID_CELL_SIZE.COLUMN_12}
                        >
                            <div className={`mt-5 mb-7 ${styles.container}`}>
                                <h2 className="leading-none">
                                    <div className={`text-center ${styles.headline}`}>404</div>
                                    <div className="text-center font-gellix text-base font-bold mb-1">
                                        Oops! This is awkward...
                                    </div>
                                </h2>
                                <p className="text-center font-gellix text-base">
                                    It looks like this page either doesn’t exist or is no longer active. Let’s find a
                                    better place for you to go.
                                </p>
                                <div className="flex justify-center mt-3">
                                    <a
                                        href="/"
                                        className={
                                            `font-gellix flex items-center text-lg font-bold px-4 py-4 h-7
                                            ${styles.cta}`
                                        }
                                    >
                                        Back to home
                                    </a>
                                </div>
                            </div>
                        </OzGridCell>
                    </OzGrid>
                </OzPage>
            </div>
        </Portal>
    );
}
